import { ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import { type IntegerType } from '@wix/ambassador-forms-v4-form/types';
import { type SomeJSONSchema } from 'ajv/dist/types/json-schema';

import { setValidationProperties } from '../../utils/validation';
import { INTEGER_VALIDATION_PROPERTIES } from '../schema-validation-properties';

import { PropertyTypes } from './property-types';

export function mapToIntegerSchemaProperty(
  integerField: IntegerType,
  validationMode: ValidationMode,
): SomeJSONSchema & { type: 'integer' } {
  return {
    type: PropertyTypes.INTEGER,
    maximum: Number.MAX_SAFE_INTEGER,
    minimum: Number.MIN_SAFE_INTEGER,
    ...resolveRestrictedValidationProperties(integerField, validationMode),
  };
}

function resolveRestrictedValidationProperties(
  integerField: IntegerType,
  validationMode: ValidationMode,
) {
  if (validationMode !== ValidationMode.UNRESTRICTED_UPDATE) {
    return {
      ...setValidationProperties<number>(
        INTEGER_VALIDATION_PROPERTIES,
        integerField,
        {
          maximum: (value) =>
            Math.min(value ?? Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER),
          minimum: (value) =>
            Math.max(value ?? Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER),
        },
      ),
    };
  }
  return {};
}
